import React, { useEffect, useRef } from 'react';
import classnames from 'classnames';
import PlainButtonOrLink from '../../../Buttons/PlainButtonOrLink';
import s from './TabButton.scss';
var TabButton = function (_a) {
    var tab = _a.tab, isActive = _a.isActive, onClick = _a.onClick, children = _a.children, focused = _a.focused, tabIndex = _a.tabIndex, onFocus = _a.onFocus, onBlur = _a.onBlur, onKeyDown = _a.onKeyDown;
    var ref = useRef(null);
    useEffect(function () {
        if (focused && ref.current) {
            ref.current.focus();
        }
    }, [focused, ref]);
    return (React.createElement(PlainButtonOrLink, { innerRef: function (node) {
            ref.current = node;
        }, tabIndex: tabIndex, role: "tab", "aria-selected": isActive, onClick: function () { return onClick(tab); }, className: classnames(s['tab'], isActive && s['selected']), onFocus: onFocus, onBlur: onBlur, onKeyDown: onKeyDown }, children));
};
TabButton.displayName = 'TabButton';
export default TabButton;
//# sourceMappingURL=TabButton.js.map